import React, { useState,useEffect } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { nightOwl } from 'react-syntax-highlighter/dist/esm/styles/prism';
import Header from '../components/header/header';
import Footer from '../components/footer/footer';
import $ from 'jquery';

const ApiDocumentation = () => {
 const [activeSection, setActiveSection] = useState('receipts');
  const [activeEndpoint, setActiveEndpoint] = useState('insertReceipt');
  const [copied, setCopied] = useState(false);

   useEffect(() => {
    // Preloader
      $(window).on('load', function () {
          $('.preloader').delay(1000).fadeOut(1000);
        });
        setTimeout(() => {
          $('.preloader').fadeOut(1000);
        }, 2000);
  });
    // Add this useEffect to log the current state
  useEffect(() => {
    // When section changes, update endpoint to the first available one
    const firstEndpoint = Object.keys(apiSections[activeSection]?.endpoints || {})[0];
    if (firstEndpoint && activeEndpoint !== firstEndpoint) {
      setActiveEndpoint(firstEndpoint);
    }
  }, [activeSection]);



  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  // API documentation data structure
  const apiSections = {
    receipts: {
      title: 'Receipts',
      description: 'Endpoints for managing receipt data',
      endpoints: {
        insertReceipt: {
          title: 'Insert Receipt',
          method: 'POST',
          path: '/insert-receipt',
          description: 'Insert a new receipt into the system',
          request: {
            headers: {
              'Content-Type': 'application/json',
              'secret-key': 'YourSecretKeyHere'
            },
            body: {
              "inv-id": "123",
              "invoice_number": "inv-112235",
              "userId": 6,
              "date": "2024-06-14 11:30:00",
              "business_id": 6,
              "branch_id": 14,
              "taxation_code": "SNTN: 000020000</BR>",
              "ims_code": "1234252123*test*",
              "tax_org": "SRB",
              "tax_org_link": "https://pos.srb.gos.pk/InvoiceVerification/InvoiceStatus.jsp?invoiceVerification=123",
              "customer_name": "abc etc",
              "customer_cell": "12345678",
              "customer_cnic": "1243214324",
              "customer_email": "demo@gmail.com",
              "invoice_status": "Active",
              "payment_mode": "Online",
              "instrument_number": "Online 956344",
              "cashier": "Cashier1",
              "subtotal_amount": 3000,
              "discount": 100,
              "total_before_tax": 2900,
              "total_tax": 300,
              "total_after_tax": 3200,
              "paid_amount": 3200,
              "remaining_amount": 0,
              "points_earned": 19,
              "points_used": 80,
              "total_points": 13.89,
              "detail": [
                {
                  "inv_detail_id": "invoice_detail_id",
                  "staff_id": 1,
                  "staff_name": "hira khan",
                  "deal_name": "deal-1",
                  "product_name": "SnowWhitening Pedicure",
                  "product_id": "22",
                  "category": "test",
                  "type": "test",
                  "barcode": "512",
                  "unit_price": 1800,
                  "qty": 1,
                  "discount_percentage": 0,
                  "tax_percentage": 9.09111111111111,
                  "tax_amount": 163.64,
                  "discount_amount": 0,
                  "total_price": 1800.02
                }
              ]
            }
          },
          response: {
            success: {
              status: 200,
              body: {
                "message": "Data inserted successfully",
                "receipt_code": "6la1k1",
                // "reciept_url": "https://receipt.mexyon.com/6la1k1",
                "Refmex_url": "https://Refmex.mexyon.com/6la1k1"
              }
            },
            error: {
              status: 404,
              body: {
                "error": "Failed to insert receipt"
              }
            }
          }
        }
      }
    },
    Refmex: {
      title: 'Refmex',
      description: 'Endpoints for managing customer Refmex',
      endpoints: {
        fetchAllRefmexs: {
          title: 'Fetch All Refmexs',
          method: 'GET',
          path: '/fetch-all-Refmexs/:businessId',
          description: 'Retrieve all Refmexs for a specific business',
          request: {
            headers: {
              'Content-Type': 'application/json'
            },
            params: {
              businessId: '123'
            }
          },
          response: {
            success: {
              status: 200,
              body: {
                "success": true,
                "Refmexs": [
                  {
                    "unique_code": "uff8g0",
                    "invoice_id": 22038,
                    "invoice_number": "2025-04-107",
                    "customer_name": "Raheela",
                    "customer_cell": "03322251025",
                    "invoice_date": "Tuesday, April 29, 2025 at 5:02 PM",
                    "branch_name": "Demo Salon",
                    "qos": "1",
                    "atmosphere": "2",
                    "experience": "4",
                    "valueformoney": "5",
                    "recommendable": "2",
                    "comment": "overall service is good",
                    "Refmex_type": ""
                  },
                  {
                    "unique_code": "iifan",
                    "invoice_id": 22037,
                    "invoice_number": "2025-04-106",
                    "customer_name": "Nosheen  Khna",
                    "customer_cell": "03052355094",
                    "invoice_date": "Wednesday, April 23, 2025 at 4:16 PM",
                    "branch_name": "Demo Salon",
                    "qos": "1",
                    "atmosphere": "3",
                    "experience": "4",
                    "valueformoney": "5",
                    "recommendable": "3",
                    "comment": "overall comments",
                    "Refmex_type": ""
                  }
                ],
                "totalRows": 2,
                "page": 1,
                "limit": 10
              }
            },
            error: {
              status: 404,
              body: {
                "error": "No Refmexs found"
              }
            }
          }
        }
      }
    }
  };




  const renderJson = (data) => {
    return (
      <SyntaxHighlighter language="javascript" style={nightOwl}>
        {JSON.stringify(data, null, 2)}
      </SyntaxHighlighter>
    );
  };

  const generateCurlCommand = () => {
    const endpoint = apiSections[activeSection].endpoints[activeEndpoint];
    let curl = `curl -X ${endpoint.method} \\\n  '${window.location.origin}${endpoint.path}'`;
    
    // Add headers
    Object.entries(endpoint.request.headers).forEach(([key, value]) => {
      curl += ` \\\n  -H '${key}: ${value}'`;
    });
    
    // Add body if exists
    if (endpoint.request.body) {
      curl += ` \\\n  -d '${JSON.stringify(endpoint.request.body)}'`;
    }
    
    return curl;
  };

  return (
    <>
      <Header />
      <div className="container-fluid about-us-container">
        <div className="preloader">
          <div className="frame">
            <div className="center">
              <div className="dot-1"></div>
              <div className="dot-2"></div>
            </div>
          </div>
        </div>  
        <section id="about-us-page" className="about-us-section">
          <div className="container-fluid zindex">
            <div className="api-documentation">
              <div className="sidebar">
                <div className="sidebar-header">
                  <h2>API Documentation</h2>
                </div>
                <div className="sidebar-sections">
                  {Object.entries(apiSections).map(([sectionKey, section]) => (
                    <div key={sectionKey} className="sidebar-section">
                      <h3 
                        className={`section-title ${activeSection === sectionKey ? 'active' : ''}`}
                        onClick={() => {
                          setActiveSection(sectionKey);
                          setActiveEndpoint(Object.keys(section.endpoints)[0]);
                        }}
                      >
                        {section.title}
                      </h3>
                      {activeSection === sectionKey && (
                        <div className="endpoint-list">
                          {Object.entries(section.endpoints).map(([endpointKey, endpoint]) => (
                            <div
                              key={endpointKey}
                              className={`endpoint-item ${activeEndpoint === endpointKey ? 'active' : ''}`}
                              onClick={() => setActiveEndpoint(endpointKey)}
                            >
                              <span className={`method ${endpoint.method.toLowerCase()}`}>
                                {endpoint.method}
                              </span>
                              <span className="path">{endpoint.path}</span>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>

              <div className="main-content-api">
                {activeSection && activeEndpoint && (
                  <>
                    <div className="api-header">
                      <h1>{apiSections[activeSection].title}</h1>
                      <p className="api-description">{apiSections[activeSection].description}</p>
                    </div>
                    <h4 className="endpoint-title">
                      {apiSections[activeSection].endpoints[activeEndpoint].title}
                    </h4>
                    
                    <h2 className="endpoint-title">
                      <span className={`method ${apiSections[activeSection].endpoints[activeEndpoint].method.toLowerCase()}`}>
                        {apiSections[activeSection].endpoints[activeEndpoint].method}
                      </span>
                      {apiSections[activeSection].endpoints[activeEndpoint].path}
                    </h2>
                    
                    <p className="endpoint-description">
                      {apiSections[activeSection].endpoints[activeEndpoint].description}
                    </p>
                    
                    <div className="documentation-section">
                      <h3>Request</h3>
                      <div className="request-details">
                        <h4>Headers</h4>
                        {renderJson(apiSections[activeSection].endpoints[activeEndpoint].request.headers)}
                        
                        {apiSections[activeSection].endpoints[activeEndpoint].request.body && (
                          <>
                            <h4>Body</h4>
                            {renderJson(apiSections[activeSection].endpoints[activeEndpoint].request.body)}
                          </>
                        )}
                      </div>
                    </div>
                    
                    <div className="documentation-section">
                      <h3>cURL Example</h3>
                      <div className="curl-example">
                        <div className="curl-command">
                          <SyntaxHighlighter language="bash" style={nightOwl}>
                            {generateCurlCommand()}
                          </SyntaxHighlighter>
                        </div>
                        <button 
                          onClick={() => copyToClipboard(generateCurlCommand())}
                          className="copy-curl-button"
                        >
                          {copied ? 'Copied!' : 'Copy cURL'}
                        </button>
                      </div>
                    </div>
                    
                    <div className="documentation-section">
                      <h3>Response</h3>
                      <div className="response-examples">
                        <div className="response-success">
                          <h4>Success Response</h4>
                          <div className="status-code">
                            Status: {apiSections[activeSection].endpoints[activeEndpoint].response.success.status}
                          </div>
                          {renderJson(apiSections[activeSection].endpoints[activeEndpoint].response.success.body)}
                        </div>
                        
                        <div className="response-error">
                          <h4>Error Response</h4>
                          <div className="status-code">
                            Status: {apiSections[activeSection].endpoints[activeEndpoint].response.error.status}
                          </div>
                          {renderJson(apiSections[activeSection].endpoints[activeEndpoint].response.error.body)}
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>

              <style jsx>{`
                .api-documentation {
                  display: flex;
                  min-height: 100vh;
                  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                }

                .sidebar {
                  width: 300px;
                  background-color: white;
                  color: #333;
                  padding: 20px;
                  overflow-y: auto;
                  height: 100vh;
                  position: sticky;
                  top: 0;
                  box-shadow: 2px 0 10px rgba(0,0,0,0.1);
                }

                .sidebar-header h2 {
                  margin: 0;
                  padding-bottom: 20px;
                  border-bottom: 1px solid #eee;
                  color: #333;
                }

                .sidebar-section {
                  margin-bottom: 15px;
                }

                .section-title {
                  cursor: pointer;
                  padding: 10px;
                  border-radius: 4px;
                  display: flex;
                  align-items: center;
                  font-weight: 600;
                  color: #333;
                }

                .section-title:hover {
                  background-color: #f5f5f5;
                }

                .section-title.active {
                  background-color: #0553d9;
                  color: white;
                }

                .endpoint-list {
                  margin-top: 10px;
                  margin-left: 15px;
                }

                .endpoint-item {
                  cursor: pointer;
                  padding: 8px 10px;
                  border-radius: 4px;
                  margin-bottom: 5px;
                  display: flex;
                  align-items: center;
                  background-color: #f9f9f9;
                  color: #333;
                }

                .endpoint-item:hover {
                  background-color: #f0f0f0;
                }

                .endpoint-item.active {
                  background-color: #0553d9;
                  color: white;
                }

                .method {
                  font-weight: bold;
                  padding: 2px 6px;
                  border-radius: 3px;
                  font-size: 12px;
                  margin-right: 10px;
                  text-transform: uppercase;
                  color: white;
                }

                .method.get {
                  background-color: #61affe;
                }

                .method.post {
                  background-color: #49cc90;
                }

                .method.put {
                  background-color: #fca130;
                }

                .method.delete {
                  background-color: #f93e3e;
                }

                .path {
                  font-family: monospace;
                  font-size: 14px;
                }

                .main-content-api {
                  flex: 1;
                  padding: 30px;
                  background-color: #f8f9fa;
                  max-width: calc(100% - 300px);
                  height: 100vh;
                  overflow-x: scroll;
                  
                }

                .api-header {
                  margin-bottom: 30px;
                }

                .api-header h1 {
                  font-size: 28px;
                  margin-bottom: 10px;
                  color: #333;
                }

                .api-description {
                  font-size: 16px;
                  color: #666;
                }

                .endpoint-title {
                  display: flex;
                  align-items: center;
                  margin-bottom: 20px;
                  font-size: 22px;
                }

                .endpoint-title .method {
                  margin-right: 15px;
                  font-size: 14px;
                }

                .endpoint-description {
                  font-size: 16px;
                  color: #555;
                  margin-bottom: 30px;
                }

                .documentation-section {
                  margin-bottom: 30px;
                  background: white;
                  padding: 25px;
                  border-radius: 8px;
                  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
                }

                .documentation-section h3 {
                  margin-top: 0;
                  margin-bottom: 20px;
                  padding-bottom: 10px;
                  border-bottom: 1px solid #eee;
                  font-size: 20px;
                  color: #333;
                }

                .documentation-section h4 {
                  margin-top: 20px;
                  font-size: 16px;
                  color: #555;
                }

                .request-details,
                .response-examples {
                  margin-top: 15px;
                }

                .status-code {
                  font-family: monospace;
                  background: #f5f5f5;
                  padding: 5px 10px;
                  border-radius: 4px;
                  display: inline-block;
                  margin-bottom: 15px;
                  font-size: 14px;
                }

                .response-success,
                .response-error {
                  margin-bottom: 25px;
                }

                .curl-example {
                  position: relative;
                  margin-top: 15px;
                }

                .curl-command {
                  background: #011627;
                  border-radius: 6px;
                  overflow: hidden;
                }

                .copy-curl-button {
                  position: absolute;
                  top: 10px;
                  right: 10px;
                  background: #0553d9;
                  color: white;
                  border: none;
                  padding: 5px 10px;
                  border-radius: 4px;
                  cursor: pointer;
                  font-size: 14px;
                  transition: all 0.2s;
                }

                .copy-curl-button:hover {
                  background: #ff5c36;
                }

                /* Responsive styles */
                @media (max-width: 768px) {
                  .api-documentation {
                    flex-direction: column;
                  }
                  
                 
                  
                  .main-content-api {
                    max-width: 100%;
                    padding: 20px;
                  }
                }
              `}</style>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default ApiDocumentation;